module.exports = __webpack_public_path__ + "05f1a3453dda8554960d318bf5ce99a0.svg";